import { ReferralCode } from '@/types/referral';

import AppApi from './app-api';

export class ReferralApi {
  constructor(private api: AppApi) {}

  async getReferralCodeByLinkValue(linkValue: string) {
    try {
      const res = await this.api.INSTANCE.get(`/referral-codes/link/${linkValue}`);
      return res.data as ReferralCode;
    } catch (e) {
      throw e;
    }
  }

  async getReferralCodeByCodeValue(codeValue: string) {
    try {
      const res = await this.api.INSTANCE.get(`/referral-codes/code/${codeValue}`);
      return res.data as ReferralCode;
    } catch (e) {
      throw e;
    }
  }

  async getReferralUseCountByUserId(userId: string) {
    try {
      const res = await this.api.INSTANCE.get(
        `/user/${userId}/referral-uses/count?from=2024-12-17&to=2024-12-31`,
      );
      return res.data as number;
    } catch (e) {
      throw e;
    }
  }
}
